import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { BiCtaNames } from '../../../bi/types';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../hooks/use-open-article-by-editor-host';
import { dataHooks } from '../../../utils/datahooks';
export const WizardFooterStatement = _ref => {
  let {
    dataHook
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    dataHook: dataHooks.wizardFooterStatement(dataHook),
    direction: "vertical",
    gap: "inherit",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, t('accessibility-wizard.footer.statement.label')), /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    size: "tiny",
    skin: "dark",
    target: "_blank",
    underline: "always",
    onClick: () => {
      biLogger.ctaClick({
        ctaName: BiCtaNames.LearnAboutAccessibility
      });
      openSelectedArticle(editorHost, 'editor-package-accessibility-wizard.articles-legal-disclaimer-help');
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, t('accessibility-wizard.footer.statement.cta'))));
};
//# sourceMappingURL=wizard-footer-statement.js.map